import React from "react";
import {
  Box,
  Divider,
  Drawer,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { format } from "date-fns";
import type { Booking } from "../../api/bookings";
import { PaymentDetailSection } from "./PaymentDetailSection";

interface BookingDetailPanelProps {
  booking: Booking | null;
  onClose: () => void;
}

export const BookingDetailPanel: React.FC<BookingDetailPanelProps> = ({
  booking,
  onClose,
}) => {
  return (
    <Drawer
      anchor="right"
      open={booking !== null}
      onClose={onClose}
      aria-label="Booking detail panel"
      PaperProps={{ sx: { width: { xs: "100%", sm: 420 }, p: 3 } }}
    >
      {booking && (
        <Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography variant="h6">Booking Detail</Typography>
            <IconButton
              size="small"
              onClick={onClose}
              aria-label="Close booking detail"
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          <Divider sx={{ mb: 2 }} />

          <Typography variant="subtitle1" fontWeight={600}>
            {booking.customer_name}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
            {booking.customer_email}
          </Typography>
          {booking.customer_phone && (
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              {booking.customer_phone}
            </Typography>
          )}

          <Typography variant="body2" sx={{ mb: 0.5 }}>
            <strong>{booking.service_name}</strong>
            {" · "}
            {format(
              new Date(booking.preferred_date_time),
              "d MMM yyyy, h:mm a"
            )}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            {booking.duration_minutes} min
          </Typography>

          {booking.notes && (
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              {booking.notes}
            </Typography>
          )}

          <PaymentDetailSection booking={booking} />
        </Box>
      )}
    </Drawer>
  );
};
